
















































































import { ValidationObserver } from 'vee-validate';

import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import { getConfig } from '@/web/utils/configuration';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import HMSpinner from '@/web/components/common/HMSpinner.vue';

export default {
  name: 'CompleteRegistration',
  components: {
    HMSpinner,
    ValidationObserver,
  },
  data() {
    return {
      password: '',
      firstName: '',
      lastName: '',
      formError: null,
      inProgress: false,
      isLoading: true,
      agreeTerms: false,
      user: null,
      registrationCompleted: false,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    config() {
      return getConfig();
    },
    styles() {
      const photoSrc =
        this.studio?.cover_photo?.storage_url ??
        this.studio?.cover_photo?.embedded_image_url;
      if (photoSrc) {
        return {
          backgroundImage: `url(${photoSrc})`,
        };
      } else return {};
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
    email() {
      return this.user?.user_email;
    },
  },
  methods: {
    async signUp() {
      this.inProgress = true;
      const data = {
        agree_terms: this.agreeTerms,
        password: this.password,
        first_name: this.firstName,
        last_name: this.lastName,
      };

      const uuid = this.$route.params.uuid;
      try {
        await this.$store.dispatch('user/completeRegistration', { uuid, data });
        await this.$store.dispatch('user/login', {
          email: this.email,
          password: this.password,
        });
        await this.$store.dispatch('user/loadUserInfo');
        this.$router.replace({ name: 'studio-dashboard' });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t(
            'STUDIO_SIGNUP.NOTIFICATIONS.FAILED_TO_COMPLETE_REGISTRATION'
          ) as string,
          duration: -1,
        });
      } finally {
        this.inProgress = false;
      }
    },
    async getUserByUUID() {
      this.isLoading = true;
      const uuid = this.$route.params.uuid;
      try {
        this.user = await this.$store.dispatch('user/getUserByUUID', uuid);
        this.firstName = this.user.user_first_name;
        this.lastName = this.user.user_last_name;
        this.registrationCompleted = this.user.registration_completed;
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t(
            'UNSUBSCRIBE.NOTIFICATIONS.FAILED_TO_LOAD_USER_WITH_THIS_TOKEN'
          ) as string,
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.getUserByUUID();
  },
};
